export default __webpack_public_path__ + "static/media/carrousel-sncc-1grau.72893dda.png";